import Model, { attr, belongsTo, hasMany } from '@ember-data/model'
import { Type } from '@warp-drive/core-types/symbols'
import { join } from 'teacher-ui-client/utils/uri'
import config from 'teacher-ui-client/config/environment'
import type BookLibraryBook from 'teacher-ui-client/models/book-library/book'
import type Teacher from 'teacher-ui-client/models/teacher'
import type StringTransform from 'teacher-ui-client/transforms/string'
import type NumberTransform from 'teacher-ui-client/transforms/number'
import type BooleanTransform from 'teacher-ui-client/transforms/boolean'
import type DateTransform from 'teacher-ui-client/transforms/date'
import type ReadonlyObjectTransform from 'teacher-ui-client/transforms/readonly-object'

export default class BookLibraryCollection extends Model {
  @attr<StringTransform>('string') declare name: string

  // Using the count attribute from the backend allows us to know how many books are in the collection, without needing
  // to access the books relationship.
  @attr<NumberTransform>('number') declare count: number

  @attr<BooleanTransform>('boolean') declare isFavourite: boolean

  @attr<DateTransform>('date') declare lastUpdated: Date

  // { path, width, height }
  @attr<ReadonlyObjectTransform>('readonly-object') declare coverPreviewImg: any

  @attr<ReadonlyObjectTransform>('readonly-object') declare coverFullImg: any

  get collectionPreviewImg() {
    const { coverPreviewImg } = this
    if (coverPreviewImg) {
      const url = join(config.libraryAssetsUrl, coverPreviewImg.path)
      return { ...coverPreviewImg, url }
    } else {
      return null
    }
  }

  get collectionFullImg() {
    const { coverFullImg } = this
    if (coverFullImg) {
      const url = join(config.libraryAssetsUrl, coverFullImg.path)
      return { ...coverFullImg, url }
    } else {
      return null
    }
  }

  @hasMany<BookLibraryBook>('book-library/book', { async: false, inverse: null }) declare books?: BookLibraryBook[]

  @belongsTo<Teacher>('teacher', { async: false, inverse: null }) declare teacher?: Teacher

  get bookIds() {
    return this.books?.map((book) => book.id)
  }

  [Type] = 'book-library/collection' as const
}
